<template>
  <div id="checkout">
    <section v-show="!loading">
      <div class="payment-info">
        <div id="payment-request-button"></div>
        {{ stripePaymentRequestInfo }}
      </div>
    </section>
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="green"
    ></v-progress-circular>

    <div id="card-errors" ref="paymentErrors" class="element-errors hide">
      {{ stripeValidationError }}
    </div>
  </div>
</template>

<script>
import stripeMixin from '../../mixins/stripe';

export default {
  name: 'stripe-mobile-payments',

  props: {
    payButtonEnabled: {
      type: Boolean,
      default: false,
    },
    orderedItem: {
      type: Object,
      default: () => {},
    },
    customerData: {
      type: Object,
      default: () => {},
    },
  },

  mixins: [stripeMixin],

  data() {
    return {
      payButtonDisabled: false,
      payElement: null,
      stripeValidationError: '',
      stripePaymentRequestInfo: '',
      clientSecret: undefined,
      loading: false,
    };
  },

  methods: {
    async createPayElement(order) {
      // Create an instance of Elements.
      const elements = this.stripe.elements();

      // Prepare the styles for Elements.
      const style = {
        base: {
          iconColor: '#666ee8',
          color: '#31325f',
          fontWeight: 400,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '15px',
          '::placeholder': {
            color: '#aab7c4',
          },
          ':-webkit-autofill': {
            color: '#666ee8',
          },
        },
      };

      const paymentRequest = await this.stripe.paymentRequest({
        country: 'DE',
        currency: 'eur',
        total: {
          label: order.name,
          amount: order.value,
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });

      this.payElement = elements.create('paymentRequestButton', {
        paymentRequest,
      });

      // Check the availability of the Payment Request API first.
      paymentRequest.canMakePayment().then((result) => {
        if (result) {
          this.payElement.mount('#payment-request-button');
        } else {
          this.stripePaymentRequestInfo = 'Zahlungsart nicht verfügbar.';
          document.getElementById('payment-request-button').style.display = 'none';
        }
      });

      paymentRequest.on('paymentmethod', (ev) => {
        // Confirm the PaymentIntent without handling potential next actions (yet).
        this.stripe
          .confirmCardPayment(
            this.clientSecret,
            { payment_method: ev.paymentMethod.id },
            { handleActions: false },
          )
          .then((confirmResult) => {
            if (confirmResult.error) {
              // Report to the browser that the payment failed, prompting it to
              // re-show the payment interface, or show an error message and close
              // the payment interface.
              this.payButtonDisabled = false;
              this.stripeValidationError = confirmResult.error.message;
              this.$refs.paymentErrors.classList.remove('hide');
              ev.complete('fail');
            } else {
              // Report to the browser that the confirmation was successful, prompting
              // it to close the browser payment method collection interface.
              ev.complete('success');
              // Check if the PaymentIntent requires any actions and if so let Stripe.js
              // handle the flow. If using an API version older than "2019-02-11" instead
              // instead check for: `paymentIntent.status === "requires_source_action"`.
              if (confirmResult.paymentIntent.status === 'requires_action') {
                // Let Stripe.js handle the rest of the payment flow.
                this.stripe.confirmCardPayment(this.clientSecret).then((result) => {
                  if (result.error) {
                    // The payment failed -- ask your customer for a new payment method.
                    this.payButtonDisabled = false;
                    this.stripeValidationError = confirmResult.error.message;
                    this.$refs.paymentErrors.classList.remove('hide');
                  } else {
                    // The payment has succeeded.
                    this.$emit('payment-successful', {
                      paidPlan: this.orderedItem,
                      paymentId: confirmResult.paymentIntent.id,
                      paidBy: 'mobile',
                    });
                    this.$refs.paymentErrors.classList.add('hide');
                  }
                });
              } else {
                // The payment has succeeded.
                this.$emit('payment-successful', {
                  paidPlan: this.orderedItem,
                  paymentId: confirmResult.paymentIntent.id,
                  paidBy: 'mobile',
                });
                this.$refs.paymentErrors.classList.add('hide');
              }
            }
          });
      });
    },
  },

  async mounted() {
    this.payButtonDisabled = true;
    this.loading = true;

    const clientSecret = await this.createPaymentIntentWallet(this.orderedItem);
    this.clientSecret = clientSecret;

    this.createPayElement(this.orderedItem);
    this.updateButtonLabel(this.orderedItem, 'Mobile');
    this.payButtonDisabled = false;
    this.loading = false;
  },
};
</script>

<style scoped>
.checkout {
}

.payment-info {
  margin: 15px auto;
  /* width: 90%; */
  padding: 10px 20px;
  border-radius: 8px;
  box-shadow: 2px 3px 3px 2px rgba(0, 0, 0, 0.25);
}

.payment-button {
  width: 90%;
  margin: 15px auto;
  padding: 8px;
  border-radius: 3px;
  background-color: yellowgreen;
  color: white;
  font-weight: bold;
}

.hide {
  display: none;
}
</style>
